import {brand} from "./brand";
import {blue} from "./blue";

export const big9 = {
    default: brand.default,
    subtle: brand.subtle,
    strong: blue[90],
};
